module.exports = __webpack_public_path__ + "static/media/archbtw.c7ca6b28.png";